<template>
  <div
    class="importation-content"
  >
    <h2 class="content-title mt-4">Data de Importação</h2>
    <SmartRow class="p-1">
      <SmartSelect
        class="sm:col-12 lg:col-4 mb-2 mr-4"
        label="Cronograma"
        itemText="name"
        itemValue="id"
        placeholder="Selecione o modo de importação"
        :items="schedule"
        v-model="valueImportationCron"
        :value="1"
      />
      <SmartInput
        class="sm:col-12 lg:col-4 mr-4 date-picker mr-2"
        label="Data de importação"
        :placeholder="'Selecione a data'"
        :disabledDate="disabledDate"
        type="date-picker"
        v-model="valueImportationDate"
        v-if="this.valueImportationCron === 1"
      />
    </SmartRow>

    <h2 class="content-title mt-4">{{ getType }}</h2>
    <SmartRow class="p-1">
      <SmartInput
        :class="{
          'sm:col-12 lg:col-4 mb-2': valueImportationType === 1,
          'sm:col-12 lg:col-4 mb-2 hide-input': valueImportationType === 2,
        }"
        ref="smart_input"
        name="plan"
        v-model="valueTableName"
        :label="valueImportationType === 2 ? 'Arquivo da tabela' : 'Nome da tabela'"
        placeholder="Digite o nome da tabela"
        type="tel"
        autocomplete="off"
      />
    </SmartRow>

    <SmartRow class="p-1 mt-3">
      <dropzone
        ref="VueDropzone"
        id="dropzone"
        :options="dropzoneOptions"
        @vdropzone-files-added="fileAdded"
        @vdropzone-removed-file="fileRemoved"
        @vdropzone-sending="sendingEvent"
        @vdropzone-complete="completeEvent"
        :use-custom-dropzone-options="true"
        :useCustomSlot=true
      >
        <div class="dropzone-custom-content">
          <v-icon :class="{ 'rotate45deg': !uploadCompleted }">{{ uploadCompleted ? 'checked' : 'attach_file' }}</v-icon>
          <h3 class="dropzone-custom-title" v-if="!uploadCompleted">Arraste um arquivo XLSX, ou clique para procurar.</h3>
          <h3 class="dropzone-custom-title" v-else>Upload concluído.</h3>
        </div>
      </dropzone>
      <SmartButton
        class="download-file-model"
        @click="downloadFileModel"
        secondary
        :loading="isDownloadingGetter"
        :disabled="disableDownloadModelFile"
      >
        Modelo Arquivo
        <SmartIcon name="download" class="mr-2" :size="1" />
      </SmartButton>
    </SmartRow>
    <SmartRow class="p-1 mt-3">
      <div>
        <SmartButton
          @click="importFile"
          quaternary
          :loading="importLoading"
          :disabled="disableButtonImport"
        >
          <SmartIcon name="upload" class="mr-2" :size="1" />
          Importar Arquivo
        </SmartButton>
      </div>
    </SmartRow>
    <hr class="separator" />

    <v-alert
      border="left"
      color="green"
      dense
      dismissible
      elevation="9"
      prominent
      type="success"
      v-model="importSuccess"
    >Monitore o progresso da importação via <a @click="() => {  this.$router.push({ name: 'importHistory' }); }">histórico de importações</a>.</v-alert>

  <smart-modal
    v-if="errorHandleGetter"
    v-bind="errorDownloadModal"
    @close="clearErrorHandle">
      {{ errorDownloadModal.text }}
  </smart-modal>
  </div>
</template>

<script>
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import moment from 'moment';
import { importCsvTerm as endPointImportCsvTerm } from 'endPoints';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'importDate',
  components: {
    DatePicker: () => import('vue2-datepicker'),
    Dropzone: () => import('vue2-dropzone'),
  },
  props: {
    type: {
      type: String,
      default: 'plan', // plan, device
    },
    valueStayContract: {
      type: Number,
      default: null,
    },
    valueImportationType: {
      type: Number,
      default: null,
    },
    valueUpdateType: {
      type: Number,
      default: null,
    },
    importationType: {
      type: Array,
      required: true,
    },
    stayContract: {
      type: Array,
      required: true,
    },
    updateType: {
      type: Array,
      required: true,
    },
    schedule: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      errorModal: null,
      isDownloading: false,
      dropzoneFiles: 0,
      importLoading: false,
      importSuccess: null,
      uploadCompleted: false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_TIM_API}${endPointImportCsvTerm}`,
        headers: { "Authorization": "Bearer " +  localStorage.token },
        addRemoveLinks: true,
        autoProcessQueue: false,
        paramName: 'file_import',
        maxFiles: 1,
        acceptedFiles: '.xlsx',
        maxFilesize: 5,
        dictFileTooBig: "Erro: Arquivo muito grande!\nSão permitidos arquivos de até {{maxFilesize}} MB.",
        dictInvalidFileType: "Erro: Tipo do arquivo inválido!\nSão permitidos arquivos apenas do tipo '.xlsx'.",
        dictCancelUpload: 'Cancelar upload',
        dictUploadCanceled: 'O upload foi cancelado.',
        dictRemoveFile: '🗑️ Remover arquivo',
        dictMaxFilesExceeded: 'Erro: É permitido o upload de apenas 1 arquivo.',
        dictResponseError: 'Erro: O servidor retornou o código de erro {{statusCode}}',
        dictFallbackMessage: 'Este navegador não suporta esta funcionalidade. Por favor, use um navegador mais moderno.',
      },
      valueImportationCron: 1,
      valueImportationCronDevice: null,
      valueImportationDate: null,
      valueTableName: null,
    }
  },
  methods: {
    ...mapActions({
      downloadFromAws: 'termDownload/downloadFromAws',
      clearErrorHandle: 'termDownload/clearErrorHandle',
    }),
    sendingEvent(file, xhr, formData) {
      formData.append('type_import', this.getTypeImport);
      formData.append('segment', this.getSegment);
      formData.append('is_schedule', this.getIsSchedule);
      formData.append('name', this.valueTableName || '');

      if (this.getScheduleDate) {
        formData.append('schedule_date', this.getScheduleDate);
      }
    },
    importFile() {
      this.importLoading = true;
      this.$refs.VueDropzone.processQueue();
    },
    async downloadFileModel() {
      if (this.isDownloadingGetter) {
        return;
      }

      const fileName = this.getFileNameModel();
      const fullPath = 'modelos/' + fileName;

      await this.downloadFromAws(fullPath);
    },
    getFileNameModel() {
      const typeStayContract = {
        'device': 'aparelho',
        'plan': 'plano',
      };
      const matrix = {
        '11': 'pos-pago-' + typeStayContract[this.type],
        '12': 'pos-pago-' + typeStayContract[this.type],
        '13': 'pos-pago-' + typeStayContract[this.type],
        '14': 'controle-' + typeStayContract[this.type],
        '15': 'controle-' + typeStayContract[this.type],
        '16': 'controle-' + typeStayContract[this.type],
        '17': 'ultrafibra-' + typeStayContract[this.type],
        '21': 'venda-cantada',
        '22': 'arquivo-carga',
      };
      let fileName = '';

      fileName = matrix[
        (
          '' +
          this.valueImportationType +
          this.valueStayContract +
          this.valueUpdateType
        ).replace('null', '')
      ] + '.xlsx';

      return fileName;
    },
    completeEvent(response) {
      if (response.status === 'success') {
        this.showSuccess();
        this.$refs.VueDropzone.removeAllFiles();
        this.$refs.VueDropzone.disable();
      }
      this.importLoading = false;
    },
    fileAdded(file) {
      this.dropzoneFiles++;
    },
    fileRemoved(file) {
      this.dropzoneFiles--;
    },
    showSuccess() {
      this.importSuccess = true;
      this.uploadCompleted = true;
    },
    disabledDate(date) {
      return date < moment();
    },
  },
  computed: {
    ...mapGetters({
      isDownloadingGetter: 'termDownload/isDownloadingGetter',
      errorHandleGetter: 'termDownload/errorHandleGetter',
    }),
    errorDownloadModal() {
      return {
        type: "warning",
        title: "Falha ao baixar o arquivo",
        icon: "warning",
        buttonText: "Ok",
        text: `${this.errorHandleGetter.message}`,
      };
    },
    disableDownloadModelFile() {
      if (this.valueImportationType === 1) {
        return !this.valueStayContract;
      }

      if (this.valueImportationType === 2) {
        return !this.valueUpdateType;
      }

      return true;
    },
    disableButtonImport() {
      return !(this.valueImportationCron &&
        (
          this.valueImportationCron === 1 && this.valueImportationDate ||
          this.valueImportationCron === 2
        ) &&
        this.dropzoneFiles);
    },
    getType() {
      const typeTrans = {
        'device': 'Aparelho',
        'plan': 'Plano',
        'update': 'Atualização',
      };

      return typeTrans[this.type];
    },
    getTypeImport() {
      return this.importationType.filter(i => i.id === this.valueImportationType)[0].value;
    },
    getSegment() {
      if (this.valueImportationType === 2) {
        return this.updateType.filter(i => i.id === this.valueUpdateType)[0].value;
      }

      return this.stayContract.filter(i => i.id === this.valueStayContract)[0].value + this.type;
    },
    getIsSchedule() {
      return this.schedule.filter(i => i.id === this.valueImportationCron)[0].value;
    },
    getScheduleDate() {
      const today = new Date();
      let scheduleDate = today;

      if (this.valueImportationDate) {
        scheduleDate = new Date(this.valueImportationDate);
      }

      if (today === scheduleDate) {
        return false;
      }

      scheduleDate = scheduleDate.toISOString().split('T')[0];

      return scheduleDate;
    }
  },
}
</script>

<style lang="scss">
.importation-content {
  .separator {
    margin: 40px 0;
  }

  .download-file-model {
    margin: 40px 0 20px 0;
  }

  .hide-input input {
    display: none;
  }

  .v-alert {
    border-color: rgba(0, 0, 0, 0.2) !important;
    position: fixed;
    bottom: 50px;
    z-index: 999;
    width: 80%;
    left: 10%;
    box-shadow: 0 0 10px 0 rgba(0,0,0,.5);
    border-radius: 10px;

    a {
      color: white;
      font-weight: 500;
      cursor: pointer;
      text-decoration: underline;
    }

    .v-alert__icon.v-icon, .theme--light.v-icon {
      color: white;
      font-size: 40px;
    }

    .v-alert__dismissible {
      cursor: pointer;
      height: 24px;
      width: 24px;
      overflow: hidden;
      display: inline-block;
      margin: 0;
      text-align: center;

      i {
        margin: 0;
        padding: 0;
        font-size: 24px!important;
        width: 12px;
        height: 12px;
        text-align: center;
        overflow: hidden;
        background: white;
        border-radius: 100%;
        color: #4caf50!important;
        box-sizing: border-box;
      }
    }
  }

  #dropzone {
    margin-right: 30px;

    &.dropzone {
      height: auto;
      min-height: 135px;
      box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, .15);
      border-radius: 8px;
      padding-bottom: 20px;
      width: 50%;

      @media (max-width: 600px) {
        width: 100%;
        margin-right: 0;
      }

      & >.dz-preview .dz-progress .dz-upload {
        background: #ddd;
      }

      & >.dz-preview .dz-remove {
        z-index: 9999;
        letter-spacing: 0;
        font-weight: 500;
        text-decoration: none!important;
        width: 100%;
        margin-left: 0;
        height: 90px;
        padding: 0;
        line-height: 90px;
        background: rgba(0,0,0,.6);
        top: 0;
        font-size: 16px;
        border-radius: 8px;
      }

      .dz-details {
        background: #669c46;
        border-radius: 8px;
      }

      .dz-error-mark {
        display: none;
      }

      .dz-message {
        position: relative;
        top: 50%;
        margin-top: -26px;
      }

      .dz-error-message {
        position: relative;
        top: 0;
        opacity: 1!important;
        background: rgba(255,0,0,0.7);
        font-weight: 500;
        letter-spacing: 2;
      }

      .dz-image {
        display: none;
      }

      .dz-preview.dz-file-preview {
        width: 100%;
        height: 90px;
        min-height: 90px;
        padding: 0;
        margin: 0;
        z-index: 9;
      }

      h3.dropzone-custom-title {
        font-weight: 500;
        line-height: 1;
        height: 100%;
        display: flex;
        align-items: flex-end;
        padding-bottom: 1em;
      }

      .dz-preview .dz-progress {
        height: 5px;
        margin-top: 5px;
      }

      .dropzone-custom-content {
        height: 56px;
        line-height: 56px;
        display: inline-block;
        width: 100%;
        text-align: left;

        i.material-icons {
          float: left;
          font-size: 36px;
          display: block;
          background: rgba(0,0,255,0.05);
          padding: 10px;
          border-radius: 100%;
          color: limegreen;
          margin: 0 10px;
          height: 54px;
          width: 54px;

          &.rotate45deg {
            transform: rotate(45deg);
          }
        }
      }
    }
  }
}
</style>
